export default __webpack_public_path__ + "static/media/phone7.6790027f.jpg";